import { addDocuments, addSizeForField } from '~/src/redux/documents/document.slice';
import type { AddDocumentsPayloadInterface } from './documents.types';
import type { TypeFilesEnum } from '~/src/models/enums/type-files.enum';
import type { Dispatch } from '@reduxjs/toolkit';

export const dropDocuments = (payload: AddDocumentsPayloadInterface<TypeFilesEnum>): (dispatch: Dispatch) => void => {

    return (dispatch: Dispatch): void => {
        dispatch(addDocuments(payload));
        dispatch(addSizeForField({ size: payload.size, typeField: payload.typeField }));
    };
};